import Transition from 'react-transition-group/Transition';
import { CustomTransitionProps } from './types';

const DEFAULT_TRANSLATE_TIMEOUT = 250;

const defaultOpacityStyle = {
  transition: `opacity ${DEFAULT_TRANSLATE_TIMEOUT}ms ease-in-out`,
  opacity: 0,
  width: '100%',
  flex: 3,
};

const transitionOpacityStyles = {
  entering: {
    opacity: 0,
  },
  entered: {
    opacity: 1,
  },
};

const CustomTransition = ({
  start,
  children,
  customStyles,
}: CustomTransitionProps): JSX.Element => (
  <Transition mountOnEnter unmountOnExit appear in={start} timeout={DEFAULT_TRANSLATE_TIMEOUT}>
    {state => (
      <div
        style={{
          ...defaultOpacityStyle,
          ...customStyles,
          ...transitionOpacityStyles[state],
        }}
      >
        {children}
      </div>
    )}
  </Transition>
);

export default CustomTransition;
